var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.boardData.length !== 0)?_c('board-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"boardData":_vm.boardData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }